import React, { useRef } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { VectorMap } from "react-jvectormap";
import "./jquery-jvectormap.scss";
import type { LocationStat } from "../../utils/dashboardMetrics";

interface LocationsProps {
  locations: LocationStat[];
  loading?: boolean;
  width?: string | number;
}

const Locations = ({ locations, loading, width }: LocationsProps) => {
  const mapRef = useRef<any>(null);
  const rows = locations.length
    ? locations.slice(0, 3)
    : [
        { name: "No data", count: 0, percent: 0 },
      ];

  return (
    <React.Fragment>
      <Col xl={4}>
        <Card>
          <CardBody>
            <div className="d-flex flex-wrap align-items-center mb-4">
              <h5 className="card-title me-2">Bookings by Location</h5>
            </div>

            <div
              id="sales-by-locations"
              data-colors='["#5156be"]'
              style={{ height: "245px" }}
            >
              <div style={{ width: width, height: 480 }}>
                <VectorMap
                  map={"us_aea"}
                  backgroundColor="transparent"
                  normalizeFunction="polynomial"
                  hoverOpacity={0.7}
                  hoverColor={false}
                  ref={mapRef}
                  containerStyle={{
                    width: "100%",
                    height: "50%",
                  }}
                  regionStyle={{
                    initial: {
                      fill: "#e9e9ef",
                      "fill-opacity": 0.9,
                      stroke: "#fff",
                      "stroke-width": 7,
                      "stroke-opacity": 0.4,
                    },
                    hover: {
                      stroke: "#fff",
                      "fill-opacity": 1,
                      "stroke-width": 1.5,
                      cursor: "pointer",
                    },
                    selected: {
                      fill: "#2938bc",
                    },
                    selectedHover: {},
                  }}
                  containerClassName="map"
                />
              </div>
            </div>

            <div className="px-2 py-2">
              {loading ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                rows.map((row, index) => (
                  <div key={`${row.name}-${index}`}>
                    <p className={index === 0 ? "mb-1" : "mt-3 mb-1"}>
                      {row.name}{" "}
                      <span className="float-end">
                        {row.count > 0 ? `${row.percent}%` : "—"}
                      </span>
                    </p>
                    <div className="progress mt-2" style={{ height: "6px" }}>
                      <div
                        className="progress-bar progress-bar-striped bg-primary"
                        role="progressbar"
                        style={{ width: `${row.percent}%` }}
                      ></div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Locations;
